import axios from 'axios';

export const revokeToken = ({ refresh_token }) => {
  return axios({
    method: 'post',
    url: `/login/logout/`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: { refresh_token },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};
